import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DashboardIcon } from '../Icons/Icon';
import ListEvents from '../../pages/Admin/EventManagement/ListEvents';

const dashboardRoutes = [
    {
        path: '/list-events',
        name: <FormattedMessage id="adminSidebar.manageXPAND" />,
        icon: DashboardIcon,
        component: ListEvents,
        layout: '/admin',
    },
];

export default dashboardRoutes;
